// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1VAsJ","title":"styles_title__2MfA_","sale":"styles_sale__i_nIk","activeSale":"styles_activeSale__1ltmn","button":"styles_button__11-Be"};